<mat-sidenav-container [ngClass]="{ 'h-screen w-full p-0 m-0': isLoginRoute$ | async }"
  class="h-screen w-full overflow-hidden dark:bg-[#0a1628] relative">
  <!-- Spinner global (si lo usas para otras cosas) -->
  <div class="fixed inset-0 flex items-center justify-center z-50 bg-black/30" *ngIf="showSpinner">
    <app-spinner></app-spinner>
  </div>

  <!-- Menu lateral -->
  <mat-sidenav #sidenav [mode]="isMobile ? 'over' : 'side'" [opened]="
      !isMobile &&
      ((user$ | async)?.role?.trim()?.toUpperCase() === 'ADMIN' ||
        (user$ | async)?.role?.trim()?.toUpperCase() === 'BACKOFFICE') &&
      (showMenu$ | async)
    " [class.mobile-sidenav]="isMobile" (openedChange)="sidenavStateService.setSidenavState($event)"
    class="w-[260px] min-w-[260px] border-r-0 shadow-none sidenav-custom overflow-hidden">
    <app-menu-list (menuToggle)="sidenav.toggle(); sidenavStateService.toggleSidenav()" (signOut)="onSignOut(sidenav)"
      [isAuthorized]="(isAuthorized$ | async) || false" [user]="user$ | async">
    </app-menu-list>
  </mat-sidenav>

  <!-- Contenido principal -->
  <mat-sidenav-content class="p-0 overflow-hidden flex flex-col" style="background-color: #f5f5f5">
    <!-- Header / Barra superior -->
    <app-header *ngIf="showMenu$ | async" (menuToggle)="sidenav.toggle(); sidenavStateService.toggleSidenav()"
      [isAuthorized]="(isAuthorized$ | async) || false" [user]="user$ | async" (signOut)="onSignOut(sidenav)"
      [isMobile]="isMobile">
    </app-header>

    <main [ngClass]="{
        'p-0 min-h-screen h-screen': isLoginRoute$ | async,
        'pt-2 px-4 pb-4 min-h-[calc(100vh-56px)] h-[calc(100vh-56px)]': !(
          isLoginRoute$ | async
        )
      }" class="transition-colors duration-300 overflow-y-auto w-full dark:bg-[#0a1628]">
      <!-- Rutas principales -->
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>